export const storyblokDateFormat = function (date: Date) {
  return (
    date.getFullYear() +
    '-' +
    ('00' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('00' + date.getDate()).slice(-2) +
    ' ' +
    ('00' + date.getHours()).slice(-2) +
    ':' +
    ('00' + date.getMinutes()).slice(-2)
  )
}

export const mediaService = function (
  url,
  width,
  height,
  quality,
  format = '',
  fill = '',
  fit = '',
  focal = '',
) {
  const options =
    'm/' + // serves webp where supported
    fit +
    '/' +
    width +
    'x' +
    height +
    '/smart/filters:quality(' +
    quality +
    ')' +
    ':format(' +
    format +
    ')' +
    ':fill(' +
    fill +
    ')' +
    ':focal(' +
    focal +
    ')'
  return [url, options].join('/')
}

export function seoImageMedia(image) {
  const width = 600
  const height = 480
  const quality = 75
  const format = 'png'
  const fill = 'eceaef'
  const fit = 'fit-in'
  const focal = image?.focus || ''

  return mediaService(image, width, height, quality, format, fill, fit, focal)
}

export const datasourceEntryTransformDefault = ({ data }): DatasourceEntry[] =>
  data.value.data.datasource_entries
